import styled from 'styled-components';
import TickIcon from '../../../../Icons/TickIcon';
import {textSizes} from '@stencil/build-theme';

export const GoStaysTagDropDownOuter = styled.div(
  props => `
    position:absolute;
    z-index:6;
    bottom: ${props.positionTop && '100%'};
    top: ${!props.positionTop && '100%'};
    padding-bottom: ${props.positionTop && '1rem'};
    padding-top: ${!props.positionTop && '1rem'};
    left: ${props.forDetailsPage ? '5%' : '10%'};
  `,
);

export const GoStaysTagContainer = styled.div(
  props => `
    position:relative;
    width: fit-content;
    cursor:pointer;
    background: ${
      props.forDetailsPage
        ? 'linear-gradient(101.67deg, #FFEDE8 0.43%, #FFFFFF 160.08%)'
        : 'linear-gradient(97.67deg, #FFFFFF -48.52%, #FFEDE8 83.5%)'
    };
    margin: ${props.margin || '0'};
    border-radius: 8px;
    display: flex;
    align-items: center;
    padding: ${props.forDetailsPage ? '8px 10px' : '6px 2px 0'};
    height: 25px;
  `,
);

export const GoStaysDropDownHover = styled.div(
  props => `
    width:30rem;
    border-radius: ${props.theme.misc.borderRadius.xlarge};
    padding:11px 16px 16px;
    // background: ${props.backgroundColor || props.theme.colors.goGreen.light};
    background: linear-gradient(110.28deg, #FFEDE8 0.67%, #FFFFFF 192.42%);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.15);
    .close {
      top: 20px;
      right: 8px;
      padding: 6px;
      display: block;
      position: absolute;
      width: 25px;
      height: 25px;
      cursor: pointer;
    }
    .close:after,
    .close::before {
      position: absolute;
      left: 11.5px;
      top: 7px;
      content: " ";
      height: 14px;
      width: 1px;
      opacity: 0.5;
      background-color: #46484D;
    }
    .close:before {
      transform: rotate(45deg);
    }
    .close:after {
      transform: rotate(-45deg);
    }
  `,
);

export const GoStaysIntroducingText = styled.div`
  ${textSizes.SmallW3}
  color: ${props => props.textColor || props.theme.colors.downriver.base};
`;

export const TickIconWrap = styled(TickIcon)(
  props => `

    width:1.2rem;
    height:1.2rem;
    fill: #FF554A;
  `,
);

export const TipUI = styled.div`
  position: absolute;
  width: 2.4rem;
  height: 2.4rem;
  left: 1.5rem;
  top: -0.1rem;
  overflow: hidden;
  &::after {
    content: '';
    position: absolute;
    width: 1.3rem;
    height: 1.2rem;
    left: 50%;
    background: ${props => props.theme.colors.goGreen.light};
    z-index: ${props => props.theme.misc.zIndex.large};
  }
`;

export const TipPositioning = styled(TipUI)`
  left: ${props => props.theme.spacing.custom(15)}
  top: ${props => !props.positionTop && '-0.1rem'};
  bottom: ${props => props.positionTop && '-0.1rem'};
  &::after {
    transform: translate(-50%, 50%) rotate(45deg);
    background: ${props => '#FFEFEA'};
    border-top: 0.1rem solid ${props => (!props.positionTop && '#FFEFEA') || 'transparent'};
    border-left: 0.1rem solid ${props => (!props.positionTop && '#FFEFEA') || 'transparent'};
    border-bottom: 0.1rem solid ${props => (props.positionTop && '#FFEFEA') || 'transparent'};
    border-right: 0.1rem solid ${props => (props.positionTop && '#FFEFEA') || 'transparent'};
  }
`;

export const GoStaysDropDownItem = styled.li(
  props => `
    display:flex;
    align-items: center;
    padding-bottom: 10px;
  `,
);

export const GoStaysDropDownItemText = styled.p(
  props => `
    font-size:${props.theme.font.custom(14)};
    color: #1F232E;
    padding-left:${props.theme.spacing.small};
  `,
);

export const GoStaysShowPropertyCta = styled.a`
  ${textSizes.BaseW3}
  font-style: normal;
  display: block;
  text-align: right;
  padding-top: 10px;
`;

export const GoStaysImg = styled.img(
  props => `
  width: 216px;
  height: 40px;
  margin: 8px 0 12px;
  `,
);

export const CertifiedGoStaysImg = styled.img(
  props => `
  width: 186px;
  height: 20px;
  margin-left: 8px;
  `,
);

export const CertifiedGoStarsImg = styled.img(
  props => `
  width: 9.5px;
  height: 9.67px;
  margin: 0 0 12px 4px;
  `,
);

export const CertifiedGoStaysText = styled.p(
  props => `
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  color: #FF554A;
  `,
);

export const FreeTag = styled.p`
  ${textSizes.SmallW3}
  background: linear-gradient(315deg, #FF3478 0%, #CF125D 100%);
  border-radius: 4px;
  padding: 2px 4px;
  margin-left: 3px;
  text-transform: uppercase;
  color: #ffffff;
`;

export const ArrowIconWrapper = styled.p(
  props => `

  background: #FF554A;
  display: flex;
  align-items:center;
  justify-content: center;
  width: 13px;
  height: 13px;
  border-radius: 50%;
  margin-left: 8px;
  :before {
    content: "";
    display: inline-block;
    width: 5px;
    height: 5px;
    margin-bottom: 2px;
    margin-left: 0;
    border-top: 1px solid white;
    border-left: 1px solid white;
    border-bottom: transparent;
    border-right: transparent;
    transform: rotate(-135deg);
  }
  `,
);

export const ArrowIconDown = styled.p(
  props => `
  background: #FF554A;
  display: flex;
  align-items:center;
  justify-content: center;
  `,
);
